import { Button, Stack } from "@mui/material";
import type { ListItemData } from "@entrilia/shared/components/inputs/CheckItemsList";
import SearchField from "@entrilia/shared/components/inputs/SearchField";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import MembersContext from "../MembersContext";
import type { MembersTab } from "../definitions";
import CompaniesFilter from "./filters/CompaniesFilter";
import MemberTypeFilter from "./filters/MemberTypeFilter";
import OrganizationRoleFilter from "./filters/OrganizationRoleFilter";

type Filter = "type" | "role" | "companies";

const availableFiltersPerTab: Record<MembersTab, Filter[]> = {
  active: ["type", "role", "companies"],
  pending: ["type", "role"],
  deactivated: [],
};

const MembersGridToolbar = () => {
  const {
    handleMembersSearch,
    filters,
    setFilters,
    clearFilters,
    companiesList,
    activeToolbarTab,
    isLoading,
    members,
  } = useDefinedContext(MembersContext);

  const showSupportValueInMembersFilter =
    activeToolbarTab === "active" && members.some((member) => member.userType === "Support");

  return (
    <Stack direction="row" sx={{ justifyContent: "space-between", gap: 1, alignItems: "center" }}>
      <Stack direction="row" spacing={2} sx={{ alignItems: "center" }}>
        <MemberTypeFilter
          disabled={isLoading || !availableFiltersPerTab[activeToolbarTab].includes("type")}
          selectedValues={filters.types}
          showSupportValue={showSupportValueInMembersFilter}
          onChange={(values) => setFilters({ ...filters, types: values })}
        />

        <OrganizationRoleFilter
          disabled={isLoading || !availableFiltersPerTab[activeToolbarTab].includes("role")}
          role={filters.role}
          onChange={(role) => setFilters({ ...filters, role })}
        />

        <CompaniesFilter
          disabled={isLoading || !availableFiltersPerTab[activeToolbarTab].includes("companies")}
          availableCompanies={companiesList}
          selectedValues={filters.companies}
          onChange={(values: ListItemData[]) => {
            setFilters({ ...filters, companies: values });
          }}
        />

        {(filters.role || filters.types.length > 0 || filters.companies.length > 0) && (
          <Button variant="text" onClick={clearFilters}>
            Clear all
          </Button>
        )}
      </Stack>
      <SearchField onSearch={handleMembersSearch} debounceTimeMs={300} />
    </Stack>
  );
};

export default MembersGridToolbar;
